<div class="content">
    <h1 class="pt-0 page-title">System Logs</h1>

    <div class="subtitle">Under Construction</div>
</div>

